import SectionBadge from "@/components/site/SectionBadge";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const GRID = "max-w-7xl mx-auto px-6 sm:px-8 md:px-12";

/**
 * FAQ accordion — questions visible, concise answers on interaction.
 * Content is force-mounted (CSS-hidden when closed) so answers remain in
 * prerendered HTML for crawlers.
 */
export default function FaqSection({
  testid,
  badge = "FAQs",
  headline = "Common questions.",
  faqs,
  tone = "light",
}) {
  const dark = tone === "dark";
  return (
    <section
      data-testid={testid}
      className={`py-16 md:py-20 ${dark ? "bg-[#050505] text-white" : "bg-white"}`}
    >
      <div className={`${GRID} grid grid-cols-12 gap-6 md:gap-10`}>
        <div className="col-span-12 md:col-span-4">
          <SectionBadge label={badge} tone={dark ? "light" : undefined} />
          <h2 className="font-serif-display text-3xl sm:text-4xl mt-6 leading-[1.1]">
            {headline}
          </h2>
        </div>
        <div className="col-span-12 md:col-span-8 reveal">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className={dark ? "border-b border-white/15" : "border-b border-black/10"}
                data-testid={`${testid}-item-${i}`}
              >
                <AccordionTrigger
                  className={`text-left font-serif-display text-lg md:text-xl hover:no-underline py-5 transition-colors duration-300 hover:text-zinc-500 ${dark ? "text-white" : "text-black"}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  forceMount
                  className={`data-[state=closed]:hidden overflow-visible leading-relaxed text-[15px] pb-5 ${dark ? "text-white/70" : "text-zinc-700"}`}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
